import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container-order-info" }
const _hoisted_2 = { class: "container-order-info__main-title" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = { for: "isInvoiceNeeded" }
const _hoisted_6 = { class: "payment-methods__container mt-4" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "w-100 text-center d-flex align-items-center justify-content-center" }
const _hoisted_9 = ["src", "title"]
const _hoisted_10 = {
  key: 1,
  class: "ms-2"
}
const _hoisted_11 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CheckBoxComponent = _resolveComponent("CheckBoxComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h4", _hoisted_2, _toDisplayString(_ctx.$t('order.order_payment')), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_CheckBoxComponent, {
          onOnClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onIsInvoiceNeededToggle($event))),
          state: _ctx.isInvoiceNeeded,
          id: "isInvoiceNeeded",
          name: "isInvoiceNeeded",
          class: "checkbox-default"
        }, {
          "checkbox-text": _withCtx(() => [
            _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.$t('order.is_invoice_needed')), 1)
          ]),
          _: 1
        }, 8, ["state"])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paymentMethods, (paymentMethod) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "payment-methods__item",
          onClick: ($event: any) => (_ctx.onPaymentMethodSelect(paymentMethod))
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["payment-methods__radio-btn", {'selected': paymentMethod.selected}])
          }, _cache[1] || (_cache[1] = [
            _createElementVNode("div", { class: "payment-methods__radio-btn__bubble" }, null, -1)
          ]), 2),
          _createElementVNode("div", _hoisted_8, [
            (paymentMethod.logoUrl)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: paymentMethod.logoUrl,
                  title: paymentMethod.title
                }, null, 8, _hoisted_9))
              : _createCommentVNode("", true),
            (paymentMethod.titleNextToLogo)
              ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                  _createElementVNode("b", null, _toDisplayString(_ctx.$t(paymentMethod.titleNextToLogo)), 1)
                ]))
              : _createCommentVNode("", true),
            (!paymentMethod.logoUrl)
              ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(paymentMethod.title), 1))
              : _createCommentVNode("", true)
          ])
        ], 8, _hoisted_7))
      }), 256))
    ])
  ]))
}